import React, { useMemo } from "react";
import useResources from "../../hooks/useResources";

const SalesPerson = ({ data }) => {
  // id  is a string and its called client_name
  const { employees } = useResources();

  const employeeName = useMemo(() => {
    if (!employees) return;
    const id = data.value;
    const foundEmployee = employees.find(
      (employee) => `${employee.id}` === `${id}`
    );
    return foundEmployee ? foundEmployee.name : "not found";
  }, [employees, data]);

  return <span>{employeeName}</span>;
};

export default SalesPerson;
